import {
  getFacet,
  getText,
  appendGOATandCountryCodeToTitle,
  sortAndSliceList,
  constructList,
} from 'shared/utils/pageMetadataUtils';
import { startCase } from 'shared/utils/startCase';
import { t } from 'localization/utils/t';

const TP = 'shared.utils.getParentCategoryMetadata';

export const getParentCategoryMetadata = ({
  pageTitle,
  pageDescription,
  constructorResponse,
  locale,
  parentCategory,
}) => {
  // Pulling out static strings for translation purposes

  const { facets = [] } = constructorResponse?.response || {};
  const brandFacet = getFacet(facets, 'brand');
  const categoryFacet = getFacet(facets, 'web_groups');
  const topThreeBrands = sortAndSliceList(brandFacet?.options);
  const sneakerCount: number = categoryFacet?.options.find(
    (option) => option.value === parentCategory,
  )?.count;

  const { constructedListWithStartCase } = constructList({
    list: topThreeBrands,
    key: 'display_name',
  });

  const parentCateogryTitle: string =
    parentCategory === 'sneakers' ? t(`${TP}.shoes`, 'Shoes') : startCase(parentCategory);
  const title = t(`${TP}.title`, 'Buy New & Iconic {parentCateogryTitle}', {
    parentCateogryTitle,
  });
  const description = t(
    `${TP}.description`,
    'Shop {parentCateogryTitle} on GOAT. Featuring {sneakerCount} new releases and iconic styles from {constructedListWithStartCase}. Authenticity assured.',
    {
      parentCateogryTitle,
      sneakerCount,
      constructedListWithStartCase: getText('', constructedListWithStartCase),
    },
  );

  return {
    pageTitle: pageTitle || appendGOATandCountryCodeToTitle(title, locale),
    pageDescription: pageDescription || description,
  };
};
